<template>
  <div
    @click="
      toggle({
        id: item.id,
        type: 1,
        status: item.status,
      })
    "
    class="adviser-visited"
  >
    <div class="order">{{ index + 1 }}</div>
    <div class="name">{{ item.presentee }}</div>

    <img
      class="imgs"
      src="../../../../../../../common/images/recommend/sex_nan_select.png"
      v-if="!item.gender"
    />
    <img
      class="imgs"
      src="../../../../../../../common/images/recommend/sex_nv_select.png"
      v-else
    />

    <div class="phone">
      {{ item.contactNumber }}
    </div>
    <!-- <div v-else class="phone">
      {{ item.contactNumber.replace(/^(\d{4})\d{4}(\d+)/, "$1****$2") }}
    </div> -->
    <div class="tabs-box">
      <template
        v-if="parseJsonString[0] || parseJsonString[1] || parseJsonString[2]"
      >
        <div
          class="one"
          v-if="parseJsonString[0] && parseJsonString[0].propertyValue"
        >
          {{ parseJsonString[0] && parseJsonString[0].propertyValue }}
        </div>
        <div
          class="two"
          v-if="parseJsonString[1] && parseJsonString[1].propertyValue"
        >
          {{ parseJsonString[1] && parseJsonString[1].propertyValue }}
        </div>
        <div
          class="three"
          v-if="parseJsonString[2] && parseJsonString[2].propertyValue"
        >
          {{ parseJsonString[2] && parseJsonString[2].propertyValue }}
        </div>
      </template>
      <!-- 暂时去掉审核中和拒绝状态 -->
      <!-- 
      <div
        :style="{
          backgroundColor: item.approveStatus === 0 ? '#0D9869' : '#CB4545',
        }"
        v-if="item.approveStatus !== 1 && type"
        class="status"
      >
        {{ item.approveStatus === 0 ? "审核中" : "拒绝" }}
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    item: Object,
    type: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    parseJsonString() {
      let obj = (this.item.tagContents &&
        JSON.parse(this.item.tagContents)) || [{}];
      return obj;
    },
  },
  methods: {
    toggle(e) {
      this.$router.push({
        name: "progressDetail",
        query: {
          id: e.id,
          type: e.type,
          status: e.status,
          approveStatus: this.item.approveStatus,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.adviser-visited {
  display: flex;
  align-items: center;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
  border-radius: 16px;
  line-height: 40px;
  color: #333333;
  margin-bottom: 30px;
  .order {
    height: 40px;

    min-width: 56px;
    max-width: 56px;
    margin: 0 20px 0 30px;
    overflow: hidden;
  }
  .name {
    height: 40px;
    min-width: 90px;
    max-width: 90px;
    overflow: hidden;
  }
  .imgs {
    margin: 0 24px 0 16px;
    width: 32px;
    height: 36px;
  }
  .phone {
    height: 40px;
    width: 180px;
    min-width: 180px;
    max-width: 180px;
    overflow: hidden;
    margin-right: 6px;
  }
  .tabs-box {
    margin-left: auto;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding-right: 30px;
    display: flex;

    .one {
      width: 74px;
      height: 48px;
      overflow: hidden;
      line-height: 48px;
      text-align: center;
      background: #d8eee7;
      border-radius: 0px 12px 12px 12px;
      color: #007458;
    }
    .two {
      width: 104px;
      height: 48px;
      overflow: hidden;
      line-height: 48px;
      text-align: center;
      background: #f6eed9;
      border-radius: 0px 12px 12px 12px;
      color: #d79414;
      margin: 0 6px;
    }
    .three {
      width: 42px;
      height: 48px;
      overflow: hidden;
      line-height: 48px;
      text-align: center;
      background: #dde9f5;
      border-radius: 0px 12px 12px 12px;
      color: #5386b8;
    }
    .status {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 28px;
      padding: 6px 14px;
      background: #0d9869;
      border-radius: 0px 16px 0px 16px;
    }
  }
}
</style>
